import { useQuery } from "@tanstack/react-query";
import { getTestimonialById } from "../../api/apiTestimonials";

export function useGetTestimonial(id) {
    const { isLoading, data, error, refetch } = useQuery({
        queryKey: ["testimonial", id],
        queryFn: () => getTestimonialById(id),
        enabled: !!id,
        retry: false,
    });

    const item = data?.data || null;

    return { isLoading, error, item, refetch };
}
